export const FormValidationMessage = {
  Required: 'This field is required',
  Max: (n: number) => `Maximum length is ${n} characters`,
  AllField: 'Please fill all required fields.',
  OnlyAlphabetic: 'Only alphabetic characters are allowed',
  InvalidEmail: 'Invalid email address',
  Min: (n: number) => `Minimum length is ${n} characters`,
  MinValue: (n: number) => `Must be at least ${n}`,
  MaxValue: (n: number) => `Must be at most ${n}`,
  Password:
    'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character',
  InvalidVersion: 'Invalid version format (e.g. 1.0.0)',
  Username: 'Username must be alphanumeric and can contain @, ., +, -, _',
  SelectAtLeastOneContact: 'Select at least one contact',
};
